export default __webpack_public_path__ + "locales/ro/Payments.json?hash=86e3c53b96bd5003be0a187c98547ea3";